module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/zh-hant/3-cd6922dd53717e93ed3c4ddafe3cff96.jpg";